import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-modal-snackbar',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  template: `
    <div class="snackbar-content">
      <span class="message">{{ data.message }}</span>

      <button
        mat-icon-button
        class="close-btn"
        aria-label="閉じる"
        (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>`,
  styles: [`
    .snackbar-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;

      background: #323232;
      color: #fff;
      padding: 12px 16px 12px 24px;
      font-size: 16px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      white-space: pre-wrap;
    }

    .snackbar-dialog .mat-mdc-dialog-container {
      padding: 0;
      border-radius: 4px;
    }

    .snackbar-backdrop {
      background: transparent;
    }

    .message {
      flex: 1;
    }

    .close-btn {
      color: #fff;
      width: 36px;
      height: 36px;
    }

    .close-btn:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  `,
  ]
})
export class ModalSnackbarComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string },
    private dialogRef: MatDialogRef<ModalSnackbarComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}

@Injectable({ providedIn: 'root' })
export class ModalSnackbarService {
  constructor(private dialog: MatDialog, private router: Router) {}

  show(message: string, url: string|undefined = undefined, duration: number = 2500, offset: number = 0): void {

    const params: any = {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'snackbar-dialog',
      backdropClass: 'snackbar-backdrop',
      data: { message },
    };

    if (offset > 0) {
      params['position'] = { top: `${offset}px` };
    }

    const dialogRef = this.dialog.open(ModalSnackbarComponent, params);

    const timer = setTimeout(() => {
      if (url) {
        this.router.navigate([url]);
      }
      dialogRef.close();
    }, duration);

    dialogRef.afterClosed().subscribe(() => {
      clearTimeout(timer);
      if (url) {
        this.router.navigate([url]);
      }
    });

  }
}
